/**
 * useVolumeDetails Hook
 *
 * Custom React Query hook for fetching a single volume resource with details.
 */

import { useQuery } from '@tanstack/react-query';
import { volumeService } from '../../../api/volume.service';

/**
 * Hook for fetching volume details
 * @param tenantId - Tenant ID
 * @param volumeId - Volume ID
 */
export const useVolumeDetails = (tenantId: string, volumeId: string) => {
  return useQuery({
    queryKey: ['volumes', tenantId, volumeId],
    queryFn: () => volumeService.getVolume(tenantId, volumeId),
    enabled: !!tenantId && !!volumeId,
    staleTime: 2 * 60 * 1000, // 2 minutes (shorter than list since details change more often)
  });
};
